// extracted by mini-css-extract-plugin
module.exports = {"root":"user-session-button_root__NMHba","logout":"user-session-button_logout__dUUxk","link":"user-session-button_link__1WeDF"};